import { Routes } from '@angular/router';
import { adResolver } from './core/resolvers/ad.resolver';
import { AdContainerComponent } from './components/ad-container/ad-container.component';
import { queryParamGuard } from './core/guards/query-param.guard';

export const routes: Routes = [

    {
        path: '',
        children: [
            {
              path: ':apiKey',
              component: AdContainerComponent,
              canActivate: [queryParamGuard],
              // resolve : {
              //     adResolver
              // }
          },
        ]
    }
];
//  https://ad.admore.app/adm_6b1a04dc1ef54d448c24bd081ea4750?publisherId=9&placementId=banner-top&adUnitId=1&sessionId=24654

//
// "publisherId": 9,
//   "placementId": "banner-top",
//   "adUnitId":1,
//   "publisherDomain": "example.com",
//   "pageUrl": "https://example.com/article/123",
//   "allowedFormats": [
//     "BANNER"
//   ],
//   "allowedSizes": [
//     "728x90"
//   ]
// }

// api key
// adm_6b1a04dc1ef54d448c24bd081ea4750